import React from "react";

const QuantitySpinner = ({ quantity, setQuantity }) => {
  const handleDecrease = () => {
    if (quantity > 1) setQuantity(quantity - 1);
  };

  const handleIncrease = () => {
    setQuantity(quantity + 1);
  };

  const handleChange = (e) => {
    const val = parseInt(e.target.value);
    if (!isNaN(val) && val > 0) {
      setQuantity(val);
    }
  };

  return (
    <div className="input-group" style={{ width: "140px" }}>
      <button
        className="btn btn-outline-secondary"
        type="button"
        onClick={handleDecrease}
      >
        −
      </button>
      <input
        type="number"
        className="form-control text-center"
        value={quantity}
        min="1"
        onChange={handleChange}
      />
      <button
        className="btn btn-outline-secondary"
        type="button"
        onClick={handleIncrease}
      >
        +
      </button>
    </div>
  );
};

export default QuantitySpinner;